import { Box } from "@mui/system";
import { Typography } from "@material-ui/core";
// components
import PageHeader from "../../components/PageHeader";

export default function UgoTerminiCondizioni() {
  return (
    <Box
      sx={{
        padding: {
          xs: "20px",
          sm: "35px",
          md: "54px",
        },
        paddingBottom: {
          xs: "100px !important",
          md: "150px !important",
        },
      }}
    >
      <PageHeader title="Condizioni di Utilizzo UGO" />

      <Box style={styles.boxParagraph}>
        <Typography style={styles.intro}>
          CONDIZIONI DI UTILIZZO UTENTI
        </Typography>
        <Typography style={styles.text}>
          Ugo Pnp S.r.l., con sede legale in 20124 – Milano, Via Panfilo Castaldi 29 (di seguito, Società o UGO PNP), ha
          realizzato la piattaforma denominata "UGO" (nel seguito, la Piattaforma) raggiungibile presso il nome a dominio
          https://hellougo.com/ ed eventuali sottodomini e di cui ha la proprietà esclusiva. Le presenti condizioni di
          utilizzo (di seguito, CU o Condizioni di Utilizzo) disciplinano i rapporti relativi ai servizi offerti da Ugo a
          favore degli utenti, come sotto definiti, e devono essere considerate congiuntamente all'Informativa sulla Privacy
          e l'informativa sui cookie.
        </Typography>
        <Typography style={styles.text}>
          Ugo PNP fornisce un insieme di servizi, tra cui uno spazio online a disposizione degli Utenti, come infra definiti,
          che permette di mettere in comunicazione gli Utenti con UGO privati, opportunamente selezionati e formati,
          disponibili alla prestazione, nei confronti degli Utenti, di servizi di affiancamento e/o accompagnamento di
          persone fragili o con ridotta mobilità, al fine di aiutarle nello svolgimento di attività quotidiane (nel seguito,
          il Servizio). Utilizzando il Servizio, l'Utente accetta le Condizioni di Utilizzo della Piattaforma.
        </Typography>
        <Typography style={styles.text}>
          Il Servizio reso da UGO PNP e l'utilizzo della Piattaforma, come infra definiti, sono soggetti all'applicazione
          delle CU e di ogni altro regolamento o policy pubblicata da UGO PNP sulla Piattaforma. In caso di disaccordo
          rispetto a qualsiasi termine o condizione o successive modifiche delle stesse, ovvero nel caso di insoddisfazione
          per i Servizi offerti da UGO PNP, l'Utente avrà facoltà e dovere di interrompere immediatamente l'uso della
          Piattaforma.
        </Typography>
        <Typography style={styles.text}>
          UGO PNP ha la facoltà, ma non l'obbligo, di far rispettare rigorosamente le Condizioni di Utilizzo attraverso la
          moderazione della comunità ed il contenzioso nelle opportune sedi giudiziarie.
        </Typography>
        <Typography style={styles.text}>
          L'Utente che intenda accedere alla Piattaforma e fruire del Servizio, presta il proprio esplicito consenso
          all'immediata attivazione del Servizio al momento della creazione dell'Account Utente e conseguentemente dichiara
          di rinunciare, così come rinuncia, al diritto di recesso nei confronti di tutte le Parti coinvolte nella
          prestazione del Servizio come indicato al precedente paragrafo. Per maggiori informazioni si rimanda al Paragrafo
          5.2 del presente documento.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          1. Definizioni
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>Condizioni di Utilizzo o CU:</span> quanto disposto nel presente documento.
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>Contenuti:</span> (i) file contenenti testi, immagini, registrazioni audio e/o video,
          dati e/o informazioni organizzati in banca di dati e comunque tutti i file, documenti e/o informazioni in qualsiasi
          formato rese dagli Utenti e che UGO PNP rende disponibili attraverso la Piattaforma, o i Servizi, incluso
          qualsiasi Contenuto concesso in licenza da una terza parte; (ii) file contenenti testi, immagini, registrazioni
          audio e/o video, dati e/o informazioni organizzati in banca dati e comunque tutti i file, documenti e/o
          informazioni in qualsiasi formato che vengono trasmessi, copiati, inviati, messi a disposizione degli Utenti della
          Piattaforma.
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>Servizio:</span> Servizi che UGO PNP offre attraverso la Piattaforma consistente in uno
          spazio online a disposizione degli Utenti, come infra definiti, che permette di mettere in comunicazione gli Utenti
          con UGO privati disponibili alla prestazione, nei confronti di persone fisiche o giuridiche, di servizi di
          affiancamento e/o accompagnamento di persone fragili o con ridotta mobilità al fine di aiutarle nello svolgimento
          di attività quotidiane.
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>Servizio UGO:</span> servizi di affiancamento e/o accompagnamento di persone fragili o
          con ridotta mobilità al fine di aiutarle nello svolgimento di attività quotidiane. Possono consistere, a mero
          titolo esemplificativo, nel fare una passeggiata, seguire insieme un ciclo di terapia, andare alle poste a pagare
          le bollette, recarsi nei negozi del quartiere per la piccola spesa quotidiana, andare al parco a leggere un libro,
          andare a una mostra oppure al cinema oppure in centro a fare due passi, ecc.
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>Progetto Extra:</span> progetto ideato, sponsorizzato o gestito in collaborazione o per
          conto di terze parti (partner), che potrebbe includere servizi normalmente non presenti sulla Piattaforma e/o
          servizi con modalità e/o a condizioni economiche agevolate.
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>Utente:</span> tutte le persone fisiche o giuridiche che accedono alla Piattaforma al
          fine di richiedere il Servizio.
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>Caregiver:</span> l'Utente che prenota il Servizio per conto dell'effettivo
          beneficiario.
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>UGO:</span> tutte le persone fisiche, opportunamente selezionate e formate, disponibili
          alla prestazione, nei confronti degli Utenti, di servizi di accompagnamento e affiancamento richiesto dall'Utente
          stesso.
        </Typography>
        <Typography style={styles.text}>
          1.2 A seconda del contesto, il significato di un termine usato al singolare comprende il plurale, quello di un
          termine usato al maschile comprende il femminile, e viceversa.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          2. Descrizione della Piattaforma
        </Typography>
        <Typography style={styles.text}>
          2.1 La Piattaforma e i Servizi comprendono una piattaforma online attraverso la quale: a) gli Utenti possono
          richiedere un UGO per la prestazione di servizi di affiancamento e/o accompagnamento che può svolgersi a piedi,
          con l'utilizzo dei mezzi pubblici, con l'ausilio di un taxi oppure tramite veicolo proprio, ovvero messo a
          disposizione dall'UGO; b) gli Utenti possono richiedere che il mezzo di trasporto, proprio oppure fornito
          dall'UGO, sia comprensivo di attrezzatura speciale volta a facilitare lo spostamento della persona con particolari
          esigenze e/o necessità; c) l'UGO fornisce all'Utente, qualora quest'ultimo lo richieda, informazioni sullo
          svolgimento del Servizio di accompagnamento e il Caregiver viene notificato della corretta conclusione del
          Servizio da parte dell'UGO; e) l'UGO e l'Utente, al termine di ogni Servizio, possono condividere la loro
          esperienza e livello di soddisfazione e/o gradimento del Servizio al fine di migliorare il Servizio per i futuri
          Utenti; f) l'Utente può effettuare il pagamento del Servizio attraverso la Piattaforma.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          3. Privacy e trattamento dei dati
        </Typography>
        <Typography style={styles.text}>
          Nel rispetto di quanto previsto dal D.Lgs. 196/2003 e ss.mm., D. Lgs 101/2018 nonché dal Reg. UE 679/2016,
          l'Utente presta il proprio inequivocabile consenso al trattamento dei dati.
        </Typography>
        <Typography style={styles.text}>
          In particolare, l'Utente dichiara di essere stato informato circa:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          a) le finalità e le modalità del trattamento cui sono destinati i dati;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          b) la natura obbligatoria o facoltativa del conferimento dei dati;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          c) le conseguenze di un eventuale rifiuto di rispondere;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          d) i soggetti o le categorie di soggetti ai quali i dati possono essere comunicati e l'ambito di diffusione dei
          dati medesimi;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          e) i diritti di cui agli artt. 15 (diritto di accesso), 16 (diritto di rettifica), 17 (diritto all'oblio), 18
          (diritto di limitazione di trattamento), 20 (diritto portabilità dati) del Regolamento;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          f) il nome, la denominazione o la ragione sociale e il domicilio, la residenza o la sede del responsabile del
          trattamento.
        </Typography>
        <Typography style={styles.text}>
          L'Utente dichiara altresì di essere stato informato che l'operatore UGO, nell'ambito dell'adempimento dei propri
          obblighi contrattuali, trattando dati in nome e per conto della UGO pnp S.r.l. (titolare del trattamento) viene
          designato quale autorizzato al trattamento e si impegna a rispettare le istruzioni impartitegli in relazione ai
          dati personali e/o particolari dei Clienti (soggetti interessati), i quali potranno essere trattati e gestiti
          unicamente per le finalità contrattuali connesse all'esecuzione del rapporto instaurato con UGO pnp S.r.l.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          4. Account Utente
        </Typography>
        <Typography style={styles.text}>
          Per iscriversi e usufruire del servizio, ogni Utente deve preventivamente creare un solo account personale, di cui
          egli sarà responsabile per tutte le attività svolte tramite esso, fornendo i dati personali che lo riguardano,
          indispensabili al corretto funzionamento del servizio di comunicazione tra persone. A tal fine, in caso di
          variazione dei dati indicati durante la fase di registrazione, l'Utente è tenuto ad aggiornare il proprio account
          concordemente alle modifiche avvenute. La creazione dell'account e la registrazione dell'Utente si perfezionano
          con la conferma della richiesta da parte dell'Utente.
        </Typography>
        <Typography style={styles.text}>
          Gli Utenti, con la creazione dell'Account Utente, certificano di avere compiuto almeno 18 anni al momento della
          loro iscrizione. Nel caso in cui l'Utente richieda il Servizio per un soggetto minore d'età, di cui egli sia
          genitore o tutore, l'Utente è tenuto alla compilazione del Modulo di Autorizzazione di Accompagnamento del Figlio
          Minorenne (nel seguito, il Modulo), che dovrà essere richiesto, compilato e inviato all'indirizzo e-mail
          customercare@hellougo.com.
        </Typography>
        <Typography style={styles.text}>
          All'interno del progetto Care Together, l'account dell'utente viene creato contestualmente all'inserimento della
          prima richiesta di servizio tramite la piattaforma Care Together.
        </Typography>
        <Typography style={{ ...styles.italic, marginBottom: "4px" }}>
          4.1 Cancellazione, Sospensione e Ban dell'Account
        </Typography>
        <Typography style={styles.text}>
          L'Utente è tenuto al rispetto delle presenti CU, alle Buone Norme e qualunque altro obbligo derivante dalla
          normativa vigente. In caso di violazione da parte dell'Utente di una o più di queste previsioni, UGO PNP si
          riserva, a sua discrezione, di procedere alla Cancellazione, Sospensione e/o Ban dell'Account del suddetto Utente.
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>Cancellazione Account:</span> L'Account del singolo Utente viene completamente rimosso
          dalla Piattaforma e ogni dato riguardante l'Utente viene cancellato.
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>Sospensione Account:</span> l'Utente mantiene il proprio Account personale oltre a poter
          accedere alla Piattaforma. Tuttavia, all'Utente sarà impedito di utilizzare i Servizi offerti sulla Piattaforma.
        </Typography>
        <Typography style={styles.text}>
          <span style={styles.bold}>Ban Account:</span> l'Account Utente verrà completamente bloccato in ogni sua
          funzionalità senza, tuttavia, venire rimosso e/o cancellato. In questo modo UGO PNP potrà impedire che l'Utente
          sottoposto a Ban crei un nuovo Account Utente riutilizzando le proprie credenziali.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          5. Servizi disponibili e prenotazione
        </Typography>
        <Typography style={styles.text}>
          I servizi disponibili nell'ambito del progetto Care Together sono:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • <span style={styles.bold}>Steward:</span> Supporto al paziente nell'onboarding alla piattaforma
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • <span style={styles.bold}>Accompagnamento:</span> Affiancamento del paziente per visite e terapie ospedaliere
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • <span style={styles.bold}>Daily Assistance:</span> supporto e compagnia al domicilio e attività di monitoraggio
          della salute della persona
        </Typography>
        <Typography style={styles.text}>
          Le modalità di fruizione del Servizio vengono concordate tra Ugo e l'Utente previa prenotazione da effettuarsi
          almeno ventiquattro (24) ore precedentemente la fornitura del Servizio. All'interno del progetto Care Together, la
          prenotazione viene effettuata direttamente tramite la piattaforma Care Together.
        </Typography>
        <Typography style={{ ...styles.italic, marginBottom: "4px" }}>
          5.1 Cancellazione della prenotazione
        </Typography>
        <Typography style={styles.text}>
          L'Utente che desideri cancellare la prenotazione di un Servizio deve darne comunicazione almeno 2 ore prima che il
          Servizio venga posto in essere tramite comunicazione e-mail all'indirizzo customercare@hellougo.com, ovvero
          effettuare, nello stesso termine, la cancellazione della prenotazione tramite l'Account personale dell'Utente. In
          caso di mancata cancellazione nei termini previsti Ugo si riserva la facoltà di addebitare all'Utente la prima ora
          di servizio, oltre al 50% del rimborso spese previsto per il servizio.
        </Typography>
        <Typography style={{ ...styles.italic, marginBottom: "4px" }}>
          5.2 Recesso
        </Typography>
        <Typography style={styles.text}>
          In conformità alla Direttiva 2011/83/UE e all'art. 52 del D. Lgs. 2005, n. 206 (nel seguito, Codice del Consumo)
          l'Utente ha il diritto di recedere dal contratto entro 14 giorni senza alcuna penalità e senza specificarne il
          motivo. Tuttavia, l'Utente, al momento dell'iscrizione alla Piattaforma, accetta esplicitamente di rinunciare a
          tale diritto poiché:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          1. Il Servizio consiste in un contenuto digitale offerto mediante un supporto non materiale che ha luogo
          immediatamente dal momento dell'iscrizione dell'Utente alla Piattaforma (art. 59, co 1 lett. o) del Codice del
          Consumo).
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          2. Il servizio offerto riguarda attività del tempo libero e il contratto prevede una data o un periodo di
          esecuzione specifici (art. 59, co 1 lett. n) del Codice del Consumo).
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          6. Obblighi dell'Utente
        </Typography>
        <Typography style={styles.text}>
          L'Utente accetta, dichiara e si impegna a:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          i) utilizzare la Piattaforma e l'Account in maniera esclusivamente personale e di non cedere a nessun titolo
          l'Account personale;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          ii) non impiegare la Piattaforma, il Servizio e l'account personale al fine di arrecare disagi, disturbo o
          inconvenienti a terzi, ovvero compiere atti illeciti e/o fraudolenti;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          iii) non intervenire e/o effettuare modifiche al software della Piattaforma, decompilare, disassemblare,
          modificare e/o creare lavori derivati dalla Piattaforma o una parte di essa;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          iv) mantenere una condotta adeguata e conforme alla natura del Servizio senza arrecare danno e/o porre in
          situazione di pericolo l'Utente stesso e l'UGO;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          v) non fare uso, trasportare con mezzo proprio o dell'UGO, consegnare e/o svolgere ogni altra attività legata
          all'impiego, uso, commercio e/o distribuzione di sostanze stupefacenti.
        </Typography>
        <Typography style={{ ...styles.italic, marginBottom: "4px" }}>
          6.2 Obblighi COVID-19
        </Typography>
        <Typography style={styles.text}>
          L'Utente si impegna nella fruizione del Servizio UGO a rispettare tutte le norme di legge nonché ogni altra regola
          tecnica tempo per tempo vigente in materia di lotta e prevenzione del COVID-19, nonché ad uniformarsi alle regole
          di buon senso e ad utilizzare la diligenza necessaria.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          7. Responsabilità di Ugo
        </Typography>
        <Typography style={{ ...styles.italic, marginBottom: "4px" }}>
          7.1 Esclusione di garanzie
        </Typography>
        <Typography style={styles.text}>
          L'Utente accetta che l'uso della Piattaforma è a suo esclusivo rischio e pericolo. Nella misura massima consentita
          dalla legge, Ugo declina ogni garanzia per altri servizi o beni ricevuti tramite o pubblicizzati sulla Piattaforma.
          Nella misura massima consentita dalla legge, Ugo declina ogni responsabilità in merito alla trasmissione di virus
          informatici o altri componenti dannosi in relazione al Piattaforma o al Servizio.
        </Typography>
        <Typography style={{ ...styles.italic, marginBottom: "4px" }}>
          7.2 Limitazioni di responsabilità
        </Typography>
        <Typography style={styles.text}>
          In nessun caso Ugo potrà essere ritenuto responsabile per danni a terzi o alle parti contraenti risultanti,
          direttamente o indirettamente, dall'uso della Piattaforma o del Servizio, o risultanti da qualsiasi contratto
          intervenuto tra l'Utente e terzi. Tale esclusione di responsabilità riguarda, tra gli altri, danni diretti,
          indiretti, accidentali, speciali, esemplari e consequenziali, inclusi: perdita di profitti, perdita di dati o
          perdita di avviamento; danni informatici; costo di prodotti o servizi sostitutivi; qualunque danno connesso a
          lesioni personali o fisiche.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          8. Sicurezza e feedback degli Utenti
        </Typography>
        <Typography style={styles.text}>
          Ugo ha a cuore la sicurezza dei propri Utenti ed il buon esito dei propri Servizi nonché delle transazioni poste
          in essere mediante la Piattaforma e pone in essere ogni sforzo finalizzato al miglior grado di trasparenza
          possibile. Tuttavia, Ugo non è tenuta a verificare l'esatta identità dei propri Utenti e UGO né può confermare
          l'identità di ciascun Utente e UGO.
        </Typography>
        <Typography style={styles.text}>
          Allo stesso modo, Ugo non è tenuto alla verifica, né preventiva né posteriore, dei commenti o feedback rilasciati
          dagli Utenti e UGO relativamente ad un Servizio. Qualora un Utente o UGO ritenga che i Feedback possano essere
          offensivi per sé stesso è pregato di darne immediata comunicazione a Ugo scrivendo a customercare@hellougo.com.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          9. Contenuti della Piattaforma
        </Typography>
        <Typography style={styles.text}>
          Tutti i Contenuti pubblicati sulla Piattaforma, trasmessi attraverso, o accessibili tramite link dalla
          Piattaforma, sono di esclusiva responsabilità dell'Utente da cui tali Contenuti provengono. L'Utente è il solo
          responsabile per qualsiasi Contenuto pubblicato, e-mail o materiale altrimenti reso disponibile tramite la
          Piattaforma.
        </Typography>
        <Typography style={{ ...styles.italic, marginBottom: "4px" }}>
          9.2 Link ad altri siti web
        </Typography>
        <Typography style={styles.text}>
          La Piattaforma, e i Servizi potrebbero contenere link a siti web o risorse di terze parti. Ugo non è responsabile
          per: (i) la disponibilità o l'accuratezza di tali siti web o risorse; o (ii) i contenuti, i prodotti, o i servizi
          su o disponibili da tali siti web o risorse. I link a tali siti web o risorse non implicano alcun sostegno da
          parte di Ugo a detti siti web o risorse.
        </Typography>
        <Typography style={{ ...styles.italic, marginBottom: "4px" }}>
          9.3 Autorizzazione dell'Utente
        </Typography>
        <Typography style={styles.text}>
          Gli Utenti e UGO autorizzano Ugo ad utilizzare ogni immagine fotografica e/o ripresa video che li ritragga durante
          lo svolgimento del Servizio, salva la facoltà di revocare tale autorizzazione mediante comunicazione scritta. Gli
          Utenti autorizzano altresì irrevocabilmente Ugo all'utilizzo di tutti i Contenuti ed ogni loro parte od elemento,
          senza restrizione alcuna, in tutto il mondo, in perpetuo.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          10. Modifiche
        </Typography>
        <Typography style={styles.text}>
          UGO PNP si riserva il diritto, a sua sola discrezione, di modificare la Piattaforma o i Servizi, ovvero di
          modificare queste CU, in qualsiasi momento e con preavviso non inferiore a 15 giorni. In caso di modifiche alle
          CU, esse saranno pubblicate sulla Piattaforma e sarà aggiornata la "Data ultimo aggiornamento" in calce alle CU.
          Continuando ad accedere o ad utilizzare la Piattaforma o i Servizi dal momento dell'avvenuto preavviso di
          modifica, l'Utente accetta tali condizioni così come modificate.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          11. Diritti di proprietà intellettuale ed industriale
        </Typography>
        <Typography style={styles.text}>
          Fatte salve le disposizioni contenute sulla Informativa per la Privacy di Ugo, qualsiasi Contenuto trasmesso
          mediante la Piattaforma dagli Utenti sarà trattato come non confidenziale e non di esclusiva proprietà. Nel caso
          in cui gli utenti detengano tutti i diritti di tali comunicazioni o Contenuti, essi concedono esplicitamente a
          Ugo ed ai suoi concessionari designati una licenza non esclusiva, con il diritto perpetuo, e in tutto il mondo, di
          copiare, distribuire, visualizzare, eseguire, pubblicare, tradurre, adattare, modificare, e/o utilizzare tale
          materiale per qualsiasi scopo.
        </Typography>
        <Typography style={styles.text}>
          Se un Utente della Piattaforma ritiene che i suoi diritti di proprietà intellettuale o industriale siano stati
          violati da una pubblicazione sulla Piattaforma da parte di un altro Utente, il primo, entro 48 ore dalla scoperta
          della violazione, deve immediatamente inviare una comunicazione scritta a Ugo all'indirizzo e-mail:
          customercare@hellougo.com.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          12. Manleva
        </Typography>
        <Typography style={styles.text}>
          L'Utente della Piattaforma si impegna a liberare, difendere, manlevare e tenere Ugo e le sue affiliate e
          consociate, e i loro funzionari, direttori, dipendenti e agenti indenni da e contro qualsiasi pretesa,
          responsabilità, danni, perdite e spese, inclusi, senza limitazione, ragionevoli onorari legali e contabili,
          derivanti da, o in qualsiasi modo correlati a: l'accesso o l'utilizzo della Piattaforma, dei Servizi o dei
          Contenuti da parte loro o la violazione delle presenti Condizioni di Utilizzo; i Contenuti elaborati, trasmessi,
          copiati, inviati, messi a disposizione dagli Utenti stessi; l'interazione con qualunque Utente; la richiesta di un
          Servizio.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          13. Gestione reclami
        </Typography>
        <Typography style={styles.text}>
          Se un Utente della Piattaforma ritiene che la condotta tenuta da altri Utenti sia inappropriata, che i suoi
          diritti di proprietà intellettuale o industriale siano stati lesi, così come la sua privacy, ovvero vi siano
          malfunzionamenti di natura tecnica della Piattaforma, l'Utente stesso, entro 48 ore dalla scoperta della
          violazione, deve immediatamente inviare una comunicazione scritta a UGO PNP S.r.l., e-mail:
          customercare@hellougo.com.
        </Typography>
        <Typography style={styles.text}>
          Per essere efficace, la notifica deve includere: la firma fisica o elettronica della persona autorizzata ad agire;
          i dati dell'Utente forniti al momento della creazione dell'Account; una spiegazione dettagliata del
          malfunzionamento ovvero della violazione; i dati personali dell'Utente che si ritiene abbia posto in essere la
          violazione; una dichiarazione che le informazioni contenute nella notifica sono accurate.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          14. Relazione tra le parti
        </Typography>
        <Typography style={styles.text}>
          Ugo, gli Utenti e gli UGO sono parti indipendenti tra loro, ognuno dei quali agisce in suo nome e per i propri
          scopi. Le presenti C.U. non creano alcun vincolo di subordinazione, di agenzia, rappresentanza, associazione,
          intermediazione, partnership, rapporto di lavoro o di franchising tra Ugo e qualsiasi Utente.
        </Typography>
        <Typography style={styles.text}>
          Il Servizio offerto da Ugo consiste esclusivamente nel mettere in contatto gli Utenti interessati a fruire del
          servizio di affiancamento/accompagnamento e gli UGO disponibili a prestare tali servizi. Ugo non è e non agisce
          come un venditore, né come compratore, rappresentante o mediatore per conto di alcuna delle parti coinvolte.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          15. Legge applicabile e foro competente
        </Typography>
        <Typography style={styles.text}>
          Le presenti Condizioni di Utilizzo sono regolate e interpretate in conformità con le leggi della Repubblica
          Italiana. Tutte le controversie per quanto riguarda la validità, interpretazione o esecuzione delle presenti
          Condizioni Generali d'Uso saranno rimesse alla competenza esclusiva del Tribunale di Milano.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.sectionTitle }}>
          16. Condizioni aggiuntive
        </Typography>
        <Typography style={styles.text}>
          La Società non è responsabile per i rapporti creatisi tra gli Utenti. L'Utente accetta che i diritti e gli
          obblighi contenuti nelle presenti Condizioni di Utilizzo possono essere liberamente e legittimamente trasferiti da
          Ugo a terze parti nel caso di fusione o acquisizione, o di altro evento. Tramite la Piattaforma, gli Utenti si
          impegnano a rispettare tutte le leggi nazionali e internazionali e tutti i regolamenti attualmente in vigore.
          Nessuna deroga alle presenti Condizioni di Utilizzo sarà concessa, senza l'autorizzazione scritta ottenuta ed un
          nuovo contratto firmato tra Ugo e l'Utente.
        </Typography>
        <Typography style={{ ...styles.text, ...styles.bold }}>
          Ultimo aggiornamento: 21/01/2022
        </Typography>
      </Box>
    </Box>
  );
}

const styles = {
  boxParagraph: {
    marginBottom: "20px",
  },
  intro: {
    fontWeight: "bold",
    fontSize: "16px",
    marginBottom: "12px",
    display: "block",
  },
  sectionTitle: {
    fontWeight: "bold",
    fontSize: "15px",
    marginBottom: "10px",
    display: "block",
  },
  text: {
    marginBottom: "8px",
    display: "block",
  },
  italic: {
    fontStyle: "italic",
    display: "block",
  },
  bold: {
    fontWeight: "bold",
  },
  indent: {
    paddingLeft: "20px",
    display: "block",
    marginBottom: "6px",
  },
};
